import { render, staticRenderFns } from "./AttributesHome.vue?vue&type=template&id=294f5b75&scoped=true"
import script from "./AttributesHome.vue?vue&type=script&lang=js"
export * from "./AttributesHome.vue?vue&type=script&lang=js"
import style0 from "./AttributesHome.vue?vue&type=style&index=0&id=294f5b75&prod&lang=scss&scoped=true"
import style1 from "./AttributesHome.vue?vue&type=style&index=1&id=294f5b75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f5b75",
  null
  
)

export default component.exports